import { LIST_INSTRUMENT_REPOSITORY_AUDITS } from "../../../gql/logBooksapi/queries";
import { fetchCommon } from "../common-for-log-sheet-and-run-logs/fetch-change-log";

export const fetchChangeLogSheets = fetchCommon({
  queryDesc: LIST_INSTRUMENT_REPOSITORY_AUDITS,
  queryName: "listInstrumentRepositoryAudits"
});
